{
  "title": "Gerir Licenças",
  "loading": "A carregar licenças...",
  "buyLicenses": "Comprar licenças",
  "product": "Produto",
  "frequency": "Frequência",
  "paymentMethod": "Método de pagamento",
  "status": "Estado",
  "nextInvoice": "Próxima fatura",
  "actions": "Ações",
  "annual": "Faturação anual",
  "monthly": "Faturação mensal",
  "manual": "Faturação manual",
  "cancelAtPeriodEnd": "Cancela em",
  "trialExpiresOn": "Período experimental termina em",
  "invoiceAmount": "no valor de",
  "nextInvoiceOn": "Próxima fatura em",
  "manageSubscription": "Gerir subscrição",
  "invoices": "Faturas",
  "loadingInvoices": "A carregar faturas...",
  "noInvoices": "Nenhuma fatura encontrada",
  "download": "Descarregar",
  "view": "Ver",
  "showing": "A mostrar",
  "of": "de",
  "previous": "Anterior",
  "page": "Página",
  "next": "Seguinte",
  "error": "Erro",
  "errorFetchingInvoices": "Erro ao obter faturas",
  "errorOpeningInvoice": "Erro ao abrir a fatura",
  "errorManageSubscription": "Erro ao abrir o portal de faturação"
  ,
  "defaultProductName": "Controlo de Horas",
  "gpsLicensesSection": "Licenças de Rastreamento GPS",
  "hoursLicensesSection": "Licenças de Controlo de Horas",
  "noGpsLicenses": "Nenhuma licença de rastreamento GPS",
  "noHoursLicenses": "Nenhuma licença de controlo de horas",
  "noLicenses": "Nenhuma licença ativa",
  "products": {
    "time_control": "Controlo de Horas",
    "gps_tracking": "Rastreamento GPS"
  },
  "statusLabels": {
    "active": "Ativo",
    "trialing": "Período experimental",
    "canceled": "Cancelado",
    "past_due": "Vencido",
    "unpaid": "Não pago",
    "incomplete": "Incompleto",
    "incomplete_expired": "Incompleto expirado"
  }
}

